import { render } from "./DoubleConfirmationButton.vue?vue&type=template&id=33429666"
import script from "./DoubleConfirmationButton.vue?vue&type=script&lang=js"
export * from "./DoubleConfirmationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/DoubleConfirmationButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33429666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33429666', __exports__)) {
    api.reload('33429666', __exports__)
  }
  
  module.hot.accept("./DoubleConfirmationButton.vue?vue&type=template&id=33429666", () => {
    api.rerender('33429666', render)
  })

}


export default __exports__